import { useState, useEffect, useContext } from "react";
import { CurrentUserContext } from "../context/RequireAuth";

export const useTimezoneMismatch = () => {
  const currentUser = useContext(CurrentUserContext);
  const [showMismatch, setShowMismatch] = useState(false);

  useEffect(() => {
    if (!currentUser?.timezone) return;

    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userTimezone = currentUser.timezone;

    const now = new Date();
    const browserOffset = new Intl.DateTimeFormat("en", {
      timeZone: browserTimezone,
      timeZoneName: "longOffset",
    })
      .formatToParts(now)
      .find((part) => part.type === "timeZoneName")?.value;

    const userOffset = new Intl.DateTimeFormat("en", {
      timeZone: userTimezone,
      timeZoneName: "longOffset",
    })
      .formatToParts(now)
      .find((part) => part.type === "timeZoneName")?.value;

    const hasMismatch = browserOffset !== userOffset;
    setShowMismatch(hasMismatch);
  }, [currentUser?.timezone]);

  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const userTimezone = currentUser?.timezone || "";

  return {
    showMismatch,
    browserTimezone,
    userTimezone,
  };
};
